import React, { useState, useEffect } from 'react';
import { Users, Linkedin, Mail } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const Team = () => {
  const [leadership, setLeadership] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadLeadership();
  }, []);

  const loadLeadership = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/team`);
      setLeadership(response.data);
    } catch (error) {
      console.error('Failed to load leadership:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <section id="team" className="py-20 bg-gradient-to-br from-white via-[#176472]/5 to-white">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center">
            <p className="text-slate-500">Loading...</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="team" className="py-20 bg-gradient-to-br from-white via-[#176472]/5 to-white">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl lg:text-6xl font-bold text-slate-900 mb-4">
            Leadership <span className="bg-gradient-to-r from-[#003366] via-[#339933] to-[#003366] bg-clip-text text-transparent">Team</span>
          </h2>
          <p className="text-lg text-slate-600">
            Meet the visionaries driving ELZALIRA's success
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {leadership.map((member, index) => {
            const isEven = index % 2 === 0;
            return (
              <Card
                key={member.id}
                className="border-0 shadow-xl hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 overflow-hidden group bg-white"
              >
                <CardContent className="p-0">
                  {/* Profile Image */}
                  <div 
                    className="relative h-80 flex items-center justify-center overflow-hidden"
                    style={{ background: isEven ? 'linear-gradient(135deg, #1E4E9E, #00B050)' : 'linear-gradient(135deg, #00B050, #1E4E9E)' }}
                  >
                    {member.image ? (
                      <img 
                        src={member.image} 
                        alt={member.name}
                        className="w-full h-full object-cover object-[center_30%] transition-all duration-500 group-hover:scale-105"
                      />
                    ) : (
                      <div className="w-32 h-32 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center border-4 border-white/40 group-hover:scale-110 transition-transform duration-300 shadow-2xl">
                        <Users className="w-16 h-16 text-white" />
                      </div>
                    )}
                  </div>

                  {/* Member Info */}
                  <div className="p-8 text-center">
                    <h3 className="text-2xl font-bold text-slate-900 mb-1">
                      {member.name}
                    </h3>
                    {member.nickname && (
                      <p className="text-sm text-slate-500 mb-3">"{member.nickname}"</p>
                    )}
                    <p className="text-[#003366] font-semibold mb-6">{member.position}</p>

                    {/* Social Links */}
                    <div className="flex justify-center space-x-4">
                      <button className="w-12 h-12 rounded-full bg-gradient-to-r from-[#003366] to-[#339933] hover:from-[#339933] hover:to-[#003366] text-white flex items-center justify-center transition-all duration-300 transform hover:scale-110 shadow-lg">
                        <Linkedin className="w-5 h-5" />
                      </button>
                      <button className="w-12 h-12 rounded-full bg-gradient-to-r from-[#339933] to-[#003366] hover:from-[#003366] hover:to-[#339933] text-white flex items-center justify-center transition-all duration-300 transform hover:scale-110 shadow-lg">
                        <Mail className="w-5 h-5" />
                      </button>
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};